import React, {useState} from "react";
import {Dialog, DialogTitle, DialogContent, Button, DialogActions} from "@mui/material";

const GDPRModal = ({open, setOpen}: { open: boolean, setOpen: any }) => {

    return (
        <div className={"modal"}>
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle style={{fontWeight: "bold"}}>
                    Notă de informare privind prelucrarea datelor cu caracter personal
                </DialogTitle>
                <DialogContent dividers style={{maxHeight: "80vh", overflowY: "auto"}}>
                    <p>
                        <strong>UNIUNEA SINDICALĂ SANITAS BUCUREȘTI</strong>, (denumită în continuare „USSB”), în
                        calitate de operator de date cu caracter personal, cu sediul în strada Măgura Vulturului nr. 31,
                        sector 2, Bucureşti, Email: <a
                        href="mailto:sanitasbucuresti@gmail.com">sanitasbucuresti@gmail.com</a>, reprezentată legal de
                        către domnul VIOREL IOAN HUȘANU, în calitate de Preşedinte, în conformitate cu prevederile
                        Regulamentului (UE) nr. 679 din 27 aprilie 2016 privind protecția persoanelor fizice în ceea ce
                        priveşte prelucrarea datelor cu caracter personal şi privind libera circulaţie a acestor date şi
                        de abrogare a Directivei 95/46/CE (Regulamentul General UE privind protecţia datelor, cunoscut
                        şi prin prescurtarea RGPD), vă adresează prezenta informare despre prelucrarea datelor
                        dumneavoastră cu caracter personal și despre drepturile ce vă revin potrivit prevederilor art.
                        13 şi 14 din Regulament și legislației naționale privind protecția și securitatea datelor
                        personale.
                    </p>

                    <p>
                        <strong>UNIUNEA SINDICALĂ SANITAS BUCUREȘTI</strong>, în calitate de operator de date în ceea ce
                        privește prelucrarea datelor cu caracter personal a persoanelor fizice vizate, respectiv a
                        membrilor săi, stabilește scopurile și mijloacele de prelucrare a respectivelor date.
                    </p>

                    <p>
                        În scopul acestei prelucrări, <strong>UNIUNEA SINDICALĂ SANITAS BUCUREȘTI</strong> depune toate
                        diligențele în vederea protejării datelor dumneavoastră cu caracter personal prin măsuri
                        conforme legislației aplicabile.
                    </p>

                    <h2>Definiţii:</h2>
                    <ol>
                        <li>
                            <strong>„Date cu caracter personal”</strong> înseamnă orice informaţii privind o persoană
                            fizică identificată sau identificabilă („persoana vizată”); o persoană fizică identificabilă
                            este o persoană care poate fi identificată, direct sau indirect, în special prin referire la
                            un element de identificare, cum ar fi un nume, un număr de identificare, date de localizare,
                            un identificator online, sau la unul sau mai multe elemente specifice, proprii identităţii
                            sale fizice, fiziologice, genetice, psihice, economice, culturale sau sociale.
                        </li>
                        <li>
                            <strong>„Prelucrare”</strong> înseamnă orice operaţiune sau set de operaţiuni efectuate
                            asupra datelor cu caracter personal sau asupra seturilor de date cu caracter personal, cu
                            sau fără utilizarea de mijloace automatizate, cum ar fi colectarea, înregistrarea,
                            organizarea, structurarea, stocarea, adaptarea sau modificarea, extragerea, consultarea,
                            utilizarea, divulgarea prin transmitere, diseminarea sau punerea la dispoziţie în orice alt
                            mod, alinierea sau combinarea, restricţionarea, ştergerea sau distrugerea.
                        </li>
                        <li>
                            <strong>„Consimţământ”</strong> al persoanei vizate înseamnă orice manifestare de voinţă
                            liberă, specifică, informată şi lipsită de ambiguitate a persoanei vizate prin care aceasta
                            acceptă, printr-o declaraţie sau printr-o acţiune fără echivoc, ca datele cu caracter
                            personal care o privesc să fie prelucrate.
                        </li>
                        <li>
                            <strong>„Persoană împuternicită de operator”</strong> înseamnă persoana fizică sau juridică,
                            autoritatea publică, agenţia sau alt organism care prelucrează datele cu caracter personal
                            în numele operatorului.
                        </li>
                        <li>
                            <strong>„Operator”</strong> înseamnă persoana fizică sau juridică, autoritatea publică,
                            agenţia sau alt organism care, singur sau împreună cu altele, stabileşte scopurile şi
                            mijloacele de prelucrare a datelor cu caracter personal.
                        </li>
                    </ol>

                    <h2>Datele cu caracter personal prelucrate</h2>
                    <p>
                        În calitatea sa de operator de date personale, <strong>UNIUNEA SINDICALĂ SANITAS
                        BUCUREȘTI</strong> prelucrează următoarele date cu caracter personal, ale membrilor săi persoane
                        fizice, în vederea reprezentării intereselor salariaților-membri şi protejării drepturilor
                        acestora: nume și prenume; cod numeric personal; serie și număr act de identitate; adresa de
                        domiciliu și/sau reședință; semnătura; date de contact (număr de telefon, adresă de e-mail) și
                        orice alte date cu caracter personal care sunt puse la dispoziție în mod voluntar de persoana
                        fizică. Se pot prelucra şi date cu caracter special, respectiv date biometrice, date privind
                        sănătatea, date privind situația familială şi/sau orice alte date pe care persoana vizată le
                        pune la dispoziție în mod voluntar, locul de muncă, studiile etc.
                    </p>

                    <h2>Scopul în care sunt prelucrate datele dumneavoastră cu caracter personal</h2>
                    <ul>
                        <li>Înregistrarea şi gestionarea calității de membru a sindicatului;</li>
                        <li>Obținerea reprezentativității în vederea negocierii contractelor colective de muncă;</li>
                        <li>Evidența cotizațiilor plătite de membri;</li>
                        <li>Soluționarea litigiilor, investigațiilor sau oricăror alte petiții/plângeri/solicitări în
                            care sindicatul este parte;
                        </li>
                        <li>Mobilizarea membrilor în acțiuni de susținere a intereselor categoriei socio-profesionale,
                            respectiv pichet de protest, marş, miting, demonstraţie sau grevă;
                        </li>
                        <li>Acordarea de ajutoare sociale și materiale pentru membrii de sindicat;</li>
                        <li>Eliberarea adeverinței de membru;</li>
                        <li>Asigurarea participării membrilor la cursuri de perfecționare profesională sau proiecte
                            finanțate din diferite fonduri;
                        </li>
                        <li>Efectuarea de analize statistice interne în scopul îmbunătățirii și diversificării
                            mijloacelor de asistență acordate de organizaţia sindicală;
                        </li>
                        <li>Realizarea de activități de publicitate de tip general, activități de fidelizare a membrilor
                            de sindicat, realizarea de sondaje, etc;
                        </li>
                        <li>Contactarea membrilor prin intermediul mijloacelor de comunicare cu scopul de a le aduce la
                            cunoștință informații importante sau de interes general;
                        </li>
                        <li>Îndeplinirea oricărui alt interes legitim al organizaţiei sindicale în contextul
                            desfășurării obiectului de activitate.
                        </li>
                    </ul>

                    <p>
                        <strong>Notă:</strong> În vederea îndeplinirii scopurilor prevăzute mai sus, <strong>UNIUNEA
                        SINDICALĂ SANITAS BUCUREȘTI</strong> vă solicită datele personale enumerate la punctul 1, care
                        vor fi prelucrate doar în scopul pentru care au fost colectate.
                    </p>

                    <h2>Temeiul juridic al prelucrării datelor dumneavoastră cu caracter personal</h2>
                    <p>
                        Prelucrarea datelor dumneavoastră cu caracter personal se întemeiază pe prevederile art. 6 alin.
                        (1) lit. a) din Regulament, persoana vizată și-a dat consimțământul pentru prelucrarea datelor
                        sale cu caracter personal pentru unul sau mai multe scopuri specifice.
                    </p>

                    <h2>Categoriile de destinatari ai datelor dumneavoastră cu caracter personal</h2>
                    <p>
                        <strong>UNIUNEA SINDICALĂ SANITAS BUCUREȘTI</strong>, prelucrează datele cu caracter personal
                        ale persoanelor vizate (salariați-membri) în deplină conformitate cu prevederile legale. Datele
                        dumneavoastră cu caracter personal vor fi prelucrate de către persoanele care au calitatea de
                        persoane împuternicite de către operator.
                    </p>
                    <p>
                        Aceste date se pot prezenta spre verificare numai organelor abilitate în acest sens şi în
                        conformitate cu legislația în vigoare.
                    </p>
                    <p>
                        <strong>Notă:</strong> Persoana vizată este informată în cel mai scurt timp de orice solicitare
                        de la terți, care face referire la datele cu caracter personal sau la calitatea de membru a
                        sindicatului, știind faptul că această calitate se încadrează la categoria specială de date cu
                        caracter personal, în conformitate cu art. 9 alin. (1) din Regulamentul UE 679/2016.
                    </p>

                    <h2>Perioada de prelucrare a datelor dumneavoastră cu caracter personal</h2>
                    <p>
                        În calitate de operator de date personale, <strong>UNIUNEA SINDICALĂ SANITAS
                        BUCUREȘTI</strong> va prelucra datele dumneavoastră cu caracter personal pe durata în care aveți
                        calitatea de membru al Sindicatului.
                    </p>
                    <p>
                        De asemenea, o parte din datele dumneavoastră personale pot fi prelucrate și ulterior, pentru un
                        termen de până la 3 ani, pentru îndeplinirea obligațiilor legale de păstrare și/sau arhivare
                        conform actelor normative în vigoare. Datele personale vor fi stocate în condiții de securitate
                        și protecție a lor, în conformitate cu condițiile și prevederile legale.
                    </p>

                    <h2>Drepturile ce vă revin în legătură cu prelucrarea datelor dumneavoastră cu caracter
                        personal</h2>
                    <p>
                        Ca urmare a prelucrării datelor, conform Regulamentului (UE) 679/2016, beneficiați de
                        următoarele drepturi:
                    </p>

                    <h3>Dreptul de acces (art. 15 din RGPD)</h3>
                    <p>
                        Aveți posibilitatea de a obține gratuit din partea <strong>USSB</strong> o confirmare
                        referitoare la prelucrarea datelor dumneavoastră cu caracter personal, precum și acces la datele
                        respective și la informațiile menționate în art. 15 din GDPR. Vă rugăm să ne contactați dacă
                        doriți o confirmare că datele dumneavoastră sunt prelucrate și dacă doriți să cunoașteți
                        modalitatea în care sunt gestionate. Răspunsul va fi furnizat în termen de o lună de la data
                        cererii.
                    </p>

                    <h3>Dreptul la rectificare (art. 16 din RGPD)</h3>
                    <p>
                        Aveți posibilitatea de a solicita <strong>USSB</strong> corectarea și/sau completarea datelor cu
                        caracter personal ce vă privesc în măsura în care acestea sunt inexacte și/sau incomplete. Vă
                        rugăm să ne informați cu privire la orice dată pe care ați dori să o rectificăm și vom răspunde
                        în termen de cel mult o lună de la data solicitării. Vom transmite modificările oricăror terțe
                        părți care trebuie să le rectifice și vă vom informa privind respectiva rectificare.
                    </p>

                    <h3>Dreptul la ștergerea datelor („dreptul de a fi uitat”) (art. 17 din RGPD)</h3>
                    <p>
                        Puteți să vă exercitați dreptul de a șterge datele dvs. personale într-un număr de situații (de
                        exemplu, dacă datele nu mai sunt necesare în raport cu scopul pentru care a fost creat sau vă
                        retrageți consimțământul). Având în vedere scopurile și temeiurile prelucrării datelor
                        dumneavoastră cu caracter personal de către <strong>UNIUNEA SINDICALĂ SANITAS BUCUREȘTI</strong>,
                        detaliate mai sus, vă puteți exercita dreptul la ștergerea respectivelor date în condițiile
                        prevăzute de art. 17 din Regulament, ulterior expirării perioadei menționate în secțiunea 5.
                    </p>

                    <h3>Dreptul la restricționarea prelucrării (art. 18)</h3>
                    <p>
                        Acest drept se poate exercita în situațiile și condițiile prevăzute de art. 18 din Regulament.
                    </p>

                    <h3>Dreptul la portabilitatea datelor (art. 20 din RGPD)</h3>
                    <p>
                        Datele dvs. se află înregistrate în format fizic și/sau electronic, în baze de date prelucrate
                        manual. În cazul în care <strong>UNIUNEA SINDICALĂ SANITAS BUCUREȘTI</strong> va prelucra prin
                        mijloace automate date cu caracter personal care vă privesc, veți avea posibilitatea de a ne
                        solicita furnizarea respectivelor date într-un format structurat, utilizat în mod curent și care
                        poate fi citit automat și de a le transfera unui alt operator de date cu caracter personal.
                    </p>

                    <h3>Dreptul la opoziţie</h3>
                    <p>
                        Aveți posibilitatea de a vă opune prelucrării, pentru motive legate de situația particulară în
                        care vă aflați, în temeiul art. 21 din Regulament.
                    </p>

                    <h3>Dreptul de a nu face obiectul unei decizii bazate exclusiv pe prelucrarea automată (art. 22 din
                        RGPD)</h3>
                    <p>
                        <strong>UNIUNEA SINDICALĂ SANITAS BUCUREȘTI</strong> nu ia decizii bazate pe prelucrarea
                        automată a datelor dumneavoastră cu caracter personal.
                    </p>

                    <h3>Dreptul de retragere a consimțământului (art. 7 alin. (3) din RGPD)</h3>
                    <p>
                        Aveți dreptul de a vă retrage consimțământul în orice moment, fără a afecta legalitatea
                        prelucrării efectuate pe baza consimțământului înainte de retragerea acestuia.
                    </p>

                    <h3>Dreptul de a depune o plângere la Autoritatea Națională de Supraveghere a Prelucrării Datelor cu
                        Caracter Personal</h3>

                    <h3>Dreptul de a vă adresa instanței de judecată</h3>
                    <p>
                        Pentru informații suplimentare sau pentru exercitarea drepturilor dumneavoastră puteți să
                        contactați în orice moment <strong>UNIUNEA SINDICALĂ SANITAS BUCUREȘTI</strong>, folosind
                        următoarele date de contact: adresa de e-mail <a
                        href="mailto:sanitasbucuresti@gmail.com">sanitasbucuresti@gmail.com</a> și/sau telefon:
                        +40753097636.
                    </p>

                    <p>
                        Termenul legal de răspuns la aceste cereri este de 30 de zile, cu posibilitatea de prelungire.
                    </p>

                    <p>
                        <strong>Declar că am luat la cunoștință și mi-am însușit prezenta notă de informare</strong>
                    </p>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)} color="primary" variant="contained">
                        Închide
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default GDPRModal;
